export function transformHtml(welcome) {
  let div = document.createElement('div')
  try {
    div.innerHTML = welcome
  } catch (e) {
    div.innerHTML = welcome
  }
  return div.innerHTML
}
